/* eslint-disable linebreak-style */
import React from 'react';
const MedicalExpenseIPMIStepShared = () => (
  <ol>
    <li>
    Copies of itemized bills and/or statement from medical providers for services rendered in connection with your claim.
    These bills and/or statements must include the date of service, the service rendered, the charge for each service, and
    the diagnosis
    </li>
    <li>
    If you have other insurance, we need the final disposition from the primary insurer listing payment or denial of your 
    claim with them (Explanation of Benefit or “EOB”).
    </li>
    <li>
    Airline Ticket Stub/Receipt (if applicable).
    </li>
    <li>
    Copies of the front and back of your cancelled checks and/or your credit card statements showing your payments for 
    the trip; and a copy of your trip invoice.
    </li>
    <li>
    Copies of your credit card statements and/or cancelled checks showing your payment for the medical service submitted
    </li>
    <li>
    If medical expenses were incurred abroad, attach copies of your passport pages which identify you as the traveler and 
    document your entrance into and exit from the country or countries where medical services were received
    </li>
  </ol>
);

export default MedicalExpenseIPMIStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.IPMI.MedicalExpense/components/MedicalExpenseIPMIStepShared.js